import { render, staticRenderFns } from "./b-popup-customer-follow-up.vue?vue&type=template&id=1f672992&scoped=true"
import script from "./b-popup-customer-follow-up.vue?vue&type=script&lang=js"
export * from "./b-popup-customer-follow-up.vue?vue&type=script&lang=js"
import style0 from "./b-popup-customer-follow-up.vue?vue&type=style&index=0&id=1f672992&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f672992",
  null
  
)

export default component.exports